import { ColumnDef } from '@tanstack/react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ColorDot } from '@/domain/termine/components/ColorPicker/ColorDot';
import { markierungMapper } from '@/domain/termine/shared/types/Markierung';
import { CopyToClipboard } from '@/components';
import { ApiKeyColumnHeader } from './ApiKeyColumnHeader';
import { KalenderTableActions } from './KalenderTableActions';
import { TFunction } from 'i18next';
import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';
import { getSortIcon } from '@/domain/termine/features/TerminKalender/Desktop/Table/utils/getSortIcon';

/* eslint-disable max-lines-per-function */
export function getKalenderTableColumns(
  t: TFunction,
  onDelete: (kalender: TerminKalender, termineCount: number) => void,
): ColumnDef<TerminKalender>[] {
  return [
    {
      accessorKey: 'name',
      header: ({ column }) => (
        <div
          className="flex items-center gap-1 cursor-pointer select-none"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}>
          {t('domain.termine.kalender.table.column.title')}
          <FontAwesomeIcon
            icon={getSortIcon(column.getIsSorted())}
            className="text-neutrals-400"
          />
        </div>
      ),
      cell: ({ row }) => (
        <div className="flex items-center gap-2">
          <ColorDot
            color={
              row.original.markierung
                ? markierungMapper[row.original.markierung]?.base
                : '#ccc'
            }
            className="w-2.5 h-2.5"
          />
          <span>{row.original.name}</span>
        </div>
      ),
    },
    {
      accessorKey: 'kalenderSchluessel',
      header: ({ column }) => <ApiKeyColumnHeader column={column} />,
      cell: ({ row }) => (
        <CopyToClipboard
          value={String(row.original.kalenderSchluessel)}
          variant="compact"
        />
      ),
    },
    {
      accessorKey: 'termineCount',
      header: () => t('domain.termine.kalender.table.column.termineCount'),
      cell: ({ row }) => <span>{row.original.termineCount ?? 0}</span>,
    },
    {
      id: 'actions',
      cell: ({ row }) => (
        <KalenderTableActions
          kalender={row.original}
          termineCount={row.original.termineCount ?? 0}
          onDelete={onDelete}
        />
      ),
    },
  ];
}
